import Toggle from "../../../ui-components/Toggle";
import React from "react";
import {PriceSelectorProps, DimensionFilterProps, ProductRow, Dimension, Filters} from "./Products.type";
import SearchSelect from "../../../ui-components/SearchSelect";

export const lkpField = {
  lines: 'prod_line_cod',
  classes: 'bdg_cls_cod',
  products: 'art_des_cmpy'
}

export function PriceSelector({intl, showPrice, setShowPrice} : PriceSelectorProps) {
  return (
    <div className="flex flex-row gap-x-2 font-bolder">
      <span>{intl.formatMessage({id: "quantity"})}</span>
      <div className="-mt-5">
        {/*@ts-ignore*/}
        <Toggle
          checked={showPrice}
          onChange={() => setShowPrice(!showPrice)}
        />
      </div>
      <span>{intl.formatMessage({id: "price"})}</span>
    </div>
  )
}

const getLineLabel = (value: string) => {
  switch (value) {
    case 'ED':
      return 'Edilizia'
    case 'PO':
      return 'Posa'
    default:
      return value
  }
}

export const getFilteredProducts = (dimension: Dimension, products: ProductRow[], filters: Filters) => {
  if (dimension === 'lines') {
    return products
  }
  let tmp = products;
  if (filters.lines.length > 0) {
    tmp = tmp.filter(i => filters.lines.map(x => x.value).includes(i.prod_line_cod))
  }

  if (dimension === 'classes') {
    return tmp
  }

  if (filters.classes.length > 0) {
    tmp = tmp.filter(i => filters.classes.map(x => x.value).includes(i.bdg_cls_cod))
  }
  return tmp
}

export function DimensionFilter({intl, products, dimension, filters, setFilters} : DimensionFilterProps) {

  const filteredProducts = getFilteredProducts(dimension, products, filters)

  // @ts-ignore
  const options = Array.from(new Set(filteredProducts.map(i => i[lkpField[dimension]]))).sort()
  return (
    <SearchSelect
      label={intl.formatMessage({id: `filter_${dimension}`})}
      options={options.map(i => ({value: i, label: dimension === 'lines' ? getLineLabel(i) : i}))}
      onChange={(e: any) => setFilters({...filters, [dimension]: e})}
      value={filters[dimension]}
      isMulti={true}
      CustomGroup={undefined}
      loadOptions={undefined}
      CustomOption={undefined}
    />
  )
}